import React from "react";
import { colors } from "../common/mixins";

interface RadioButtonProps {
  color?: string;
  showDot?: boolean;
}

export const RadioButton = ({ color = colors.primary, showDot = true }: RadioButtonProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3537_31838)">
      <path
        d="M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {showDot && (
        <path
          d="M8 11.5C9.933 11.5 11.5 9.933 11.5 8C11.5 6.067 9.933 4.5 8 4.5C6.067 4.5 4.5 6.067 4.5 8C4.5 9.933 6.067 11.5 8 11.5Z"
          fill={color}
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </g>
    <defs>
      <clipPath id="clip0_3537_31838">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
